export default {
    FreezeMe : 'FreezeMe',
    UnfreezeMe : 'UnfreezeMe',
}